import svg from './row-svg/check-v2.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function CheckV2Icon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default CheckV2Icon;
